import http from './http';
import api from '../config/a16-pregled-listica-config.json';

export const pregledListicaService = {
    getSlog: (slog) => http.post(`${api.getListicSlog}`, slog),
    getListic: (listic) => http.post(`${api.getListic}`, listic)
};
